const graficas = {
  ObtenDatosDeGraficas: 'Forseti/Estadisticos/GetDatosDeGraficas'
}

const estadisticos = {
  graficas: graficas
}

export default estadisticos;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/forseti/sistema/estadisticos/estadisticos.js
// module id = null
// module chunks = 